import TokenManager from "@/api/tokenManager/TokenManager"
import store from "@/store/index.js";
import { apiClient } from "@/api"; 

export default class FirebaseAuthenticationService
{
    tokenManager = null

    constructor()
    {
        this.tokenManager = new TokenManager();
    }

    configureUserDetectionSubscription()
    {
        const me = this
        let firebase = this.tokenManager.getFirebaseSDK()
        firebase.auth().onAuthStateChanged(function(user) {
            if (user && !user.isAnonymous) {
                apiClient.requestForTokenRefresh().then(() => {
                    me.login()
                })
            } else {
                console.debug('isAnonymousUser', user ? user.isAnonymous : 'no user')
            }
            // unsubscribeFunction()
        }, function(error) {
            console.log(error);
        });
    }

    login() 
    {
        if (store.getters['resort/resort']) {
            store.dispatch('auth/setLogged')
        }
    }
}